// extracted by mini-css-extract-plugin
export default {"location__text":"style_location__text__lBdPc","location__container":"style_location__container__a0ilK","location__map-container":"style_location__map-container__ns9A0"};